export const NEW_ACCOUNTID_CHANNEL = 'AccountIDChannel';
